(function() {

	"use strict"

	angular.module( "ATMGurus" )

	.service( "ConsoleService", [
		function() {

			return {
				content: [],
				// excluded: ["api/nav", "api/customer/addresses"],
				append: function( output ) {


					// if ( _.indexOf( this.excluded, output["End Point"] ) === -1 ) {
						this.content.push( output )
						this.content.push("------------------------------------------------------------------------------------------------------------------");
					// }
				},
				getContent: function() {
					return this.content;
				},
			}
		}
	])

})()


// WEBPACK FOOTER //
// ./src/app/services/ConsoleService.js